import ImageMediaDataData from 'app/Models/Content/ImageMediaDataData';
import {ContentReferenceProperty, StringProperty} from '@episerver/spa-core/Property';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';

export type ImageProps = {
  src: string;
  alt: string;
};

export type BackgroundImageProps = {
  style: {backgroundImage: string} | null;
  title: string;
};

export const getImageProps = (data: ContentReferenceProperty, context: IEpiserverContext): ImageProps => {
  const image = data?.expandedValue as ImageMediaDataData;
  const src = image?.url ? context.getEpiserverUrl(image.url) : null;
  const alt = image?.altText?.value ?? '';
  return {src, alt};
};

export const getImageSrc = (url?: string, context?: IEpiserverContext): string => {
  const src = url && context ? context.getEpiserverUrl(url) : null;
  return src;
};

export const getBackgroundImageProps = (data: ContentReferenceProperty, context: IEpiserverContext): BackgroundImageProps => {
  const {src, alt: title} = getImageProps(data, context);
  const style = src ? {backgroundImage: `url(${src})`} : null;
  return {style, title};
};

export const getVideoLink = (data: StringProperty | ContentReferenceProperty, context: IEpiserverContext) => {
  const url = typeof data?.value == 'string' ? data.value : data?.value?.url;

  return url ? context.getEpiserverUrl(data.value) : null;
};
